import { TableContainer } from "../../../DemandaCriada/styles";

interface BlocoOrientacaoProps {
    orientacaoAntes: string;
    orientacaoDepois: string;
}

export default function BlocoOrientacao({ orientacaoAntes, orientacaoDepois }: BlocoOrientacaoProps) {
    const antes = orientacaoAntes?.trim() || '';
    const depois = orientacaoDepois?.trim() || '';

    return (
        <div className="expanded-section">
            <h4 className="section-title">Principal</h4>
            <TableContainer>
                <table className="data-table">
                    <thead>
                        <tr>
                            <th className="field-col-three">Campo</th>
                            <th className="before-col">Antes</th>
                            <th className="after-col">Depois</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="field-cell">Conteúdo</td>
                            <td className="before-cell">{antes || '—'}</td>
                            <td className="after-cell">{depois || '—'}</td>
                        </tr>
                    </tbody>
                </table>
            </TableContainer>
        </div>
    );
}

